import React, { useEffect, useRef } from 'react';
import { usePostHog } from 'posthog-js/react';
import { useAuth } from '../../hooks/useAuth';

const PostHogAuthBridge: React.FC = () => {
  const posthog = usePostHog();
  const { user, isAuthenticated } = useAuth();
  const lastIdentifiedUserIdRef = useRef<string | null>(null);

  useEffect(() => {
    if (!posthog) return;

    if (isAuthenticated && user) {
      const userId = String(user.id);
      if (lastIdentifiedUserIdRef.current === userId) return;

      posthog.identify(userId, {
        email: user.email,
        username: user.username,
        is_admin: user.is_admin,
      });
      lastIdentifiedUserIdRef.current = userId;
      return;
    }

    if (lastIdentifiedUserIdRef.current) {
      posthog.reset();
      lastIdentifiedUserIdRef.current = null;
    }
  }, [posthog, isAuthenticated, user]);

  return null;
};

export default PostHogAuthBridge;
